import { RG_TYPE } from '../../types/rg-type.js';
import { DefaultWall } from './default-wall.js';

const DefaultBalcony = {
    type: RG_TYPE.Balcony,
    size: [4, 0.6, 2],
    anchor: [0.5, 0, 0.5],
    name: 'balcony',
    children: [
        { ...DefaultWall, pos: [0, 0, 3], rot: [180, 0, 180] },
        { ...DefaultWall, pos: [-3, 0, 0], rot: [0, 90, 0] },
        { ...DefaultWall, pos: [3, 0, 0], rot: [0, -90, 0] },
        {
            type: RG_TYPE.Floor,
            size: [1, 0.7, 0.11],
            pos: [0, 0, 0],
            anchor: [0.5, 0, 0.5],
            name: 'floor',
            children: [],
            color: '#CEE9BD'
        }
    ]
};

export { DefaultBalcony };
//# sourceMappingURL=default-balcony.js.map
